import { useEffect } from 'react';


export default function RejectModal({
  isRejectModalOpen,
  setIsRejectModalOpen,
  handleRejectInsight,
  rejectingInsightId,
  insights,
  rejectReason,
  setRejectReason,
}) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsRejectModalOpen(false);
      }
    };
    if (isRejectModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isRejectModalOpen, setIsRejectModalOpen]);

  if (!isRejectModalOpen) return null;

  return (
    <div className="fixed inset-0 z-[160] bg-black/60 flex items-center justify-center p-4" onClick={(e) => { if (e.target === e.currentTarget) setIsRejectModalOpen(false); }}>
      <form onSubmit={handleRejectInsight} className="w-full max-w-md bg-gray-800 border border-gray-700 rounded-lg shadow-xl p-4 space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-white">Hintを却下</h2>
          <button aria-label="閉じる" type="button" onClick={() => setIsRejectModalOpen(false)} className="text-gray-400 hover:text-white text-xl leading-none">
            ×
          </button>
        </div>
        
        <div>
          <p className="text-xs text-gray-500 mb-1">対象</p>
          <h3 className="text-sm font-bold text-white">{insights.find(i => i.id === rejectingInsightId)?.title || 'Untitled Hint'}</h3>
        </div>

        <div className="space-y-1">
          <label htmlFor="reject-reason" className="block text-xs font-medium text-gray-400">理由（任意）</label>
          <textarea
            id="reject-reason"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="例：すでにAsset化済み、事実誤認がある、等"
            className="w-full bg-gray-700 border border-gray-600 text-white p-2 rounded text-sm focus:outline-none focus:border-blue-500 h-24"
          />
        </div>

        <div className="flex gap-2 pt-2">
          <button type="button" onClick={() => setIsRejectModalOpen(false)} className="flex-1 bg-gray-700 text-white py-2 rounded text-sm font-bold">
            キャンセル
          </button>
          <button type="submit" className="flex-1 bg-red-600 hover:bg-red-500 text-white py-2 rounded text-sm font-bold">
            却下する
          </button>
        </div>
      </form>
    </div>
  );
}
